/**
 * KEPT FOR BACKWARD COMPATIBILITY
 */
import './index'

import { TsComponentRegistry } from '@components/ts-component-registry'
import { initReactComponents, initReactInAuthorMode } from '@react/react-component-registry'

const cache = {}

function importAll(requireContext: __WebpackModuleApi.RequireContext) {
  // eslint-disable-next-line space-before-function-paren
  requireContext.keys().forEach(key => {
    cache[key] = requireContext(key)
    return cache
  })
}

// Defer component class registration to DOMContentLoaded so it does not
// extend the module-boot Long Task. importAll MUST finish before
// TsComponentRegistry.initComponents() — both are inside the same callback.
document.addEventListener('DOMContentLoaded', () => {
  importAll(require.context('../components', true, /^((?!\/?__tests__|videodetails|filterable-list\/).)*\.ts$/))

  /**
   * kicks off js execution of components
   */
  TsComponentRegistry.initComponents()
})

initReactComponents()
initReactInAuthorMode()
